
import {Component, Vue} from "vue-property-decorator";
import {DBService} from "@/components/Database/DBService";

@Component
export default class Downloads extends Vue {
  downloads: any[] = [];

  constructor() {
    super();
    this.getDownloadsFromDB()
  }

  async getDownloadsFromDB() {
    const downloads = (await DBService.getInstance().getDownloads()) as any[];
      this.downloads = downloads;
  }

  readFile(file: string) {
    window.open(file, '_blank') //to open in new tab
  }

}

